import { css } from '@emotion/react'

import useClientInfo from '../services/useClientInfo'
import BackButton from './BackButton'
import { mapChildren } from './Button'
import Grid from './Grid'

export default function CheckoutLayout(props: {
  backButtonLink?: string
  left: React.ReactNode
  right: React.ReactNode
}) {
  const client = useClientInfo()

  const leftElements = mapChildren(props.left, (element, index) => (
    <Grid.Row key={element.key || index}>{element}</Grid.Row>
  ))

  if (client.isMobile()) {
    return (
      <div>
        <BackButton to={props.backButtonLink} />

        <Grid spacing={15}>
          {leftElements as any}
          <Grid.Row>{props.right}</Grid.Row>
        </Grid>
      </div>
    )
  }

  return (
    <div>
      <div>
        <BackButton to={props.backButtonLink} />
      </div>

      <Grid spacing={20}>
        <Grid.Col flex={2}>
          <Grid spacing={20}>{leftElements}</Grid>
        </Grid.Col>

        <Grid.Col
          flex={1.5}
          css={css`
            max-width: 400px;
          `}
        >
          {props.right}
        </Grid.Col>
      </Grid>
    </div>
  )
}
